import cn from "classnames";
import PanelTemplate from "components/shared/profile/panel";
import Select from "components/shared/select";
import { assistantChatReportTypesEnum } from "helpers/enums";
import React from "react";
import { applyReportDisallowedUsers, getReportDisallowedUsers } from "sources/assistantChat";
import { config } from "./config";

class ReportUsers extends PanelTemplate {
    state = {
        data: { userIds: [] },
        users: [],
        selectedUserId: undefined,
        loading: false,
        isValid: true,
    };

    componentDidMount() {
        getReportDisallowedUsers(assistantChatReportTypesEnum.MonthResult).then((data) => {
            const userIds = data.map((item) => item.id);
            this.setState({ data: { userIds }, users: data, initial: { userIds: [...userIds] } });
        });
    }

    renderBody = () => {
        const { editable, config } = this.props;
        return (
            <>
                {this.renderAddUser(config.userId, editable)}
                {this.renderSelectedUsers()}
            </>
        );
    };

    saveUsers = (users, clearSelectedUser = false) => {
        const data = { userIds: users.map((user) => user.id) };
        const selectedUserState = clearSelectedUser ? { selectedUserId: undefined } : {};

        this.setState({ loading: true });
        return applyReportDisallowedUsers({ ...data, reportType: assistantChatReportTypesEnum.MonthResult })
            .then(
                (res) => {
                    if (res) {
                        this.setState({
                            data,
                            users,
                            initial: { userIds: [...data.userIds] },
                            shouldUpdate: false,
                            isValid: true,
                            ...selectedUserState,
                        });
                    } else {
                        this.setState({ isValid: false, ...selectedUserState });
                    }
                },
                () => this.setState({ isValid: false, ...selectedUserState }),
            )
            .finally(() => this.setState({ loading: false }));
    };

    selectUser = ({ value, option }) => {
        if (!value || !option || this.state.loading) {
            return;
        }
        const users = [...this.state.users, { id: value, displayName: option.fullNameOrEmail }];
        this.setState({ selectedUserId: value });
        return this.saveUsers(users, true);
    };

    removeUser = (user) => {
        if (this.state.loading) {
            return;
        }
        const users = this.state.users.filter((item) => item.id !== user.id);
        const action = () => this.saveUsers(users);
        const { modal } = this.props;

        if (modal) {
            return modal({
                name: "confirm",
                title: "Удалить исключение?",
                text: `Пользователь «${user.displayName}» будет получать ежемесячный отчёт.`,
                buttons: { confirm: "Получать отчёт", cancel: "Не получать" },
                action,
            });
        }

        return action();
    };

    renderAddUser = (config, editable) => {
        const { selectedUserId, users, loading } = this.state;
        return (
            <>
                <div className="mb-2">Не отправлять ежемесячный отчёт следующим пользователям</div>
                <div className="mb-3">
                    <Select
                        {...config}
                        inputProps={{ ...config.inputProps, disabled: !editable || loading }}
                        value={selectedUserId}
                        onChange={this.selectUser}
                        excludeItems={users.map((user) => user.id)}
                    />
                </div>
            </>
        );
    };

    renderSelectedUsers = () => {
        const { editable } = this.props;
        const { users, loading } = this.state;

        if (!users.length) {
            return <div className="panel__empty-msg">Исключения не выбраны</div>;
        }

        return (
            <table className="table table-sm mb-0">
                <thead className="thead-light">
                    <tr>
                        <th>#</th>
                        <th>Пользователь</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    {users.map((user, index) => (
                        <tr key={user.id}>
                            <td>{index + 1}</td>
                            <td>{user.displayName}</td>
                            <td className="text-right">
                                {editable && (
                                    <button
                                        type="button"
                                        className="btn btn-xs btn-outline-danger"
                                        disabled={loading}
                                        onClick={() => this.removeUser(user)}
                                    >
                                        Удалить
                                    </button>
                                )}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    };

    render() {
        const { loading } = this.state;
        const cname = cn("card card-body mb-3", {
            "border-danger": !this.state.isValid,
            loading,
        });
        return (
            <div className={cname}>
                <div className="row">
                    <div className="col-sm-4">
                        <h5>Рассылка ежемесячного отчёта</h5>
                    </div>
                    <div className="col-sm-8">{this.renderBody()}</div>
                </div>
            </div>
        );
    }
}

const ConfiguredPanel = (props) => <ReportUsers {...props} config={config} />;

export default ConfiguredPanel;
